import { RouterLinks } from './routes/AppRoutes'
import Routing from './routes/MyRoutes';

import {
  Components,
  RouterProvider,
  Suspense,
  store,
  Provider,
  ToastContainer,
  useLocation,
  useEffect,
  AOS
} from './utils/npm'
import { useLayoutEffect } from 'react'
import { ScrollToTop } from './utils/utils'
import { BrowserRouter, Router } from 'react-router-dom'
// import Header from './components/Header'
// import Footer from './components/Footer'

const { Loader, Header, Footer } = Components

function App() {
  // Hook to listen for location changes
  useLayoutEffect(() => {
    ScrollToTop()
    const canonicalLink = document.querySelector('link[rel="canonical"]');
if (canonicalLink) {
} else {
}
  }, [])

  // return (
  //   <Provider store={store}>
  //     <Suspense
  //       fallback={null}
  //     >
  //       <ToastContainer
  //         position='top-right'
  //         autoClose={3000}
  //         hideProgressBar={false}
  //         newestOnTop={false}
  //         closeOnClick
  //         rtl={false}
  //         pauseOnFocusLoss
  //         draggable
  //         pauseOnHover
  //         theme='light'
  //         limit={1}
  //       />
  //       <Header />
  //       <RouterProvider
  //         router={routerLinks}
  //         future={{
  //           v7_startTransition: true
  //         }}
  //       />
  //       <Footer />
  //     </Suspense>
  //   </Provider>
  // )

  
  

  return (<>
  
    {/* // <BrowserRouter> */}
    {/* <Provider store={store}> */}
    {/* <Header /> */}
    {/* <Suspense fallback={<Loader />}> */}

    <ToastContainer
      position='top-right'
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme='light'
      limit={1}
    />

    {/* <RouterProvider router={RouterLinks} /> */}
    <Routing />

    {/* </Suspense> */}
    {/* <Footer /> */}
    {/* </Provider> */}
    {/* // </BrowserRouter> */}
  </>)
}

export default App
